export default {
  computed: {
    showPreview() {
      return this.$store.getters.showPreview;
    },
    selectedAttachment() {
      return this.$store.getters.selectedAttachment;
    },
    currentAttachments() {
      return this.$store.getters.currentAttachments;
    },
  },
  methods: {
    toggleShowAttachmentPreview(toggleValue, attachment, attachmentsArray) {
      this.$store.dispatch('toggleShowPreview', toggleValue);
      this.$store.dispatch('updateSelectedAttachment', attachment);
      this.$store.dispatch('updateAttachmentsArray', attachmentsArray);
    },
  },
};
